import api from '../api';

export default {
    async getDataWebsite(accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/portal/website`,  {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao carregar dados do site:', error);
                throw error;
        }
    },

}

